import { useMemo } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchMsrReport } from './kpiDashboardApi';

const STALE_MS = 60_000;
const GC_MS = 10 * 60_000;

function msrReportEnabled(filterValues: Record<string, string | string[]>): boolean {
  const customer = filterValues.customer as string;
  return Boolean(customer && customer !== 'All');
}

export function useMsrReport(
  filterKey: string,
  filterValues: Record<string, string | string[]>,
  options: { enabled: boolean }
) {
  const timezoneOffset = useMemo(() => new Date().getTimezoneOffset(), []);
  const customerSelected = msrReportEnabled(filterValues);

  return useQuery({
    queryKey: ['kpi-msr-report', filterKey, timezoneOffset],
    queryFn: () => fetchMsrReport(filterValues, timezoneOffset),
    enabled: options.enabled && customerSelected,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: keepPreviousData,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export { msrReportEnabled };
